import { Report } from './report';

export class CpanelReport extends Report {}
